/**
 * Mock data for the operations "Running Promotion" page — the acquisition
 * RunningCampaign template with operations copy (Spark - OWS - Running
 * Promotion). The hero leads with "Players engaged" instead of Ad Spend, and
 * there is no creative-assets grid. The "also in use for Acquisition" crosslink
 * is NOT set here — it is added per-promotion by the operations-promotion-detail
 * dispatcher only when the promotion has a linked Acquisition campaign (matched
 * by `Promotion.linkKey`), so promotions without a counterpart show no link.
 * Temporary — remove when wired to an API (see docs/mock-data.md).
 */
import type { RunningCampaignData } from './types';

const ART = '/assets/marketing/campaign-halloween.png';

export const operationsRunningCampaignData: RunningCampaignData = {
  header: { title: 'Running Promotion Details' },
  hero: {
    image: ART,
    title: 'Halloween is coming!',
    subtitle: '100 Free Spins on our most popular Halloween games.',
    adSpend: { value: '91', label: 'Players engaged' },
    offering: { value: '100 Free Spins', label: 'Offering' },
    duration: { value: 'October 22 - October 30', label: 'Duration' },
  },
  performance: {
    kpis: [
      {
        id: 'activated-players',
        title: 'Activated players',
        subtitle: 'Reactivated (dormant to active)',
        today: { value: '38', change: '+12%', changeType: 'increase' },
        month: { value: '612', change: '+19%', changeType: 'increase' },
      },
      {
        id: 'turnover-increase',
        title: 'Turnover increase',
        subtitle: 'Extra money wagered by players',
        today: { value: '$4,200', change: '+15%', changeType: 'increase' },
        month: { value: '$58,300', change: '+27%', changeType: 'increase' },
      },
      {
        id: 'deposits-triggered',
        title: 'Deposits triggered',
        subtitle: 'Deposits prompted by the promotion',
        today: { value: '62', change: '+9%', changeType: 'increase' },
        month: { value: '910', change: '+21%', changeType: 'increase' },
      },
      {
        id: 'ggr-increase',
        title: 'GGR increase',
        subtitle: 'Gross Gaming Revenue uplift',
        today: { value: '$1,180', change: '+6%', changeType: 'increase' },
        month: { value: '$15,400', change: '+18%', changeType: 'increase' },
      },
    ],
  },
};

export default operationsRunningCampaignData;
